/* eslint-disable camelcase */
import { get, isEmpty } from 'lodash-es';
import Pluralize from 'pluralize';
import PropTypes from 'prop-types';
import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import Price from '../../../../../../app/frontend/components/components/utils/numbers/Price';
import Button from '../../../../shared/components/Button';
function ContentRightsCard({ contentRights, isLogged, contentRightsExpirationInstructions, showMoreDetails = true }) {
  const location = useLocation();
  const offerId = useSelector(store => get(store, 'offer.offerId'));
  const { t } = useTranslation();

  return (<Card className="mb-2">
    <Card.Header>
      <Card.Title className='mb-2'>
        {t('influencers.pages.campaign.glance.content_rights.title')}
      </Card.Title>
    </Card.Header>
    <Card.Body className="text-1">
      {
        !isLogged ?
          <span>
            <Link className="link" to={{
              pathname: "/signin",
              state: { from: location.pathname }
            }}>
              {t('influencers.common.sign_in')}
            </Link>&nbsp;
            {t('influencers.pages.campaign.glance.to_see_content_rights')}
          </span> :
          <React.Fragment>
            <div className="text-medium-1">
              {t('influencers.pages.campaign.glance.content_rights.subtitle')}
            </div>
            
            {
              !isEmpty(contentRightsExpirationInstructions) ?
                <div
                  dangerouslySetInnerHTML={{
                    __html: contentRightsExpirationInstructions
                  }}></div> :
                !isEmpty(contentRights) ?
                  <React.Fragment>
                    { contentRights.map(elem => (
                      <React.Fragment key={elem.id} >
                        <div className="text-1">
                          <Price number={parseFloat(elem.influencer_payment_amount)} currency={elem.currency} precision={0} />
                          {t('influencers.pages.campaign.glance.content_rights.payment_desc', {
                            platform: t(`influencers.common.${elem.platform}`),
                            media_type: t(`influencers.common.${Pluralize(elem.media_type)}`)
                          })}
                        </div>
                      </React.Fragment>
                    )) }
                  </React.Fragment> :
                  null
            }
          </React.Fragment>
      }

    </Card.Body>
    {
      isLogged ?
        <Card.Footer>
          { showMoreDetails &&
          <Button to={`/offer/${offerId}/questions#content_rights`} as={Link} variant="tertiary">
            <span className='text-underline'>{t('influencers.pages.campaign.more_details')}</span>
            <i className="fal fa-arrow-right icon-right"></i>
          </Button> }
        </Card.Footer> : null
    }
  </Card>);
}

ContentRightsCard.propTypes = {
  contentRights: PropTypes.array.isRequired,
  isLogged: PropTypes.bool
};

ContentRightsCard.defaultProps = {
  isLogged: false
};


export default React.memo(ContentRightsCard);
